import { render, staticRenderFns } from "./UserFullNameBtn.vue?vue&type=template&id=75804312"
import script from "./UserFullNameBtn.vue?vue&type=script&lang=js"
export * from "./UserFullNameBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports